module.exports = __webpack_public_path__ + "img/shichang.8926eae6.png";